'use client';

import { FlashMessage } from './FlashMessages';
import SupportEmailLink from './SupportEmailLink';
import SupportTwitterLink from './SupportTwitterLink';

export default function ErrorFlashMessage({ sessionOrSessionData, message }) {
  return (
    <FlashMessage
      type="error"
      showClose={false}
      message={
        <div className="flex flex-col space-y-4">
          <div>{message}</div>

          <p>
            <span className="font-semibold">This is likely temporary</span>.
            Please try again in a minute or so.
          </p>

          <p>
            Otherwise, please reach out at{' '}
            <SupportEmailLink sessionOrSessionData={sessionOrSessionData} /> or{' '}
            <SupportTwitterLink sessionOrSessionData={sessionOrSessionData} />{' '}
            if you need help.
          </p>
        </div>
      }
    />
  );
}
